import React, { useState } from 'react';
import { projects } from '../data/mockData';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle } from
'./ui/dialog';
import { X } from 'lucide-react';

export const ProjectsSection = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(() => setSelectedProject(null), 300);
  };

  return (
    <section id="projects" className="py-20 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Selected Projects

          </h2>
          <p className="text-lg text-slate-300 max-w-3xl mx-auto">
            Proven delivery of major infrastructure and capital works projects
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) =>
          <div
            key={project.id}
            onClick={() => handleProjectClick(project)}
            className="bg-slate-800 rounded-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-slate-700 cursor-pointer">

              <div className="relative h-48 overflow-hidden">
                <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-110" />

              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3">
                  {project.title}
                </h3>
                <p className="text-slate-300 leading-relaxed">
                  {project.description}
                </p>
                <p className="text-blue-400 text-sm mt-4 font-semibold">
                  Click to read more →
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Project Detail Modal */}
      <Dialog open={isOpen} onOpenChange={handleClose}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-slate-900">
              {selectedProject?.title}
            </DialogTitle>
          </DialogHeader>
          {selectedProject &&
          <div className="space-y-6">
              <div className="relative h-64 rounded-lg overflow-hidden">
                <img
                src={selectedProject.modalImage || selectedProject.image}
                alt={selectedProject.title}
                className="w-full h-full object-cover" />

              </div>
              
              <div className="space-y-4">
                <div className="flex items-center space-x-2">
                  <span className="text-sm font-semibold text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
                    {selectedProject.value}
                  </span>
                </div>
                <DialogDescription className="text-base text-slate-700 leading-relaxed whitespace-pre-line">
                  {selectedProject.detailedDescription || selectedProject.description}
                </DialogDescription>
              </div>
            </div>
          }
        </DialogContent>
      </Dialog>
    </section>);

};